export function getBrowserStorageAdapter() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return {
    getItem: (key: string) => {
      return localStorage.getItem(key);
    },
    setItem: (key: string, value: string) => {
      localStorage.setItem(key, value);
    },
    removeItem: (key: string) => {
      localStorage.removeItem(key);
    },
  };
}
